import {
    INITIAL_CHART_TEMPLATE,
    manageChartTemplateReducer,
} from './ManageChartTemplateReducer';
import React, { useReducer } from 'react';

import { ManageChartTemplateContext } from './ManageChartTemplateContext';

const ManageChartTemplateProvider = ({
    children,
}: {
    children: JSX.Element;
}) => {
    const [state, dispatch] = useReducer(
        manageChartTemplateReducer,
        INITIAL_CHART_TEMPLATE,
    );

    return (
        <ManageChartTemplateContext.Provider value={{ state, dispatch }}>
            {children}
        </ManageChartTemplateContext.Provider>
    );
};

export default ManageChartTemplateProvider;
